import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/element.js'
import VueLazyload from 'vue-lazyload'

const imageUrl = "http://img01.cmicawards.org.cn" //图片预览路径


Vue.use(VueLazyload)

Vue.config.productionTip = false


Vue.prototype.$imageUrl = imageUrl



new Vue({
	store,
	router,
	render: h => h(App),
}).$mount('#app')
